export const base_url = "https://api.lavanyagurukul.com";

export const RAZORPAY_TEST_KEY = "rzp_test_QwRkxxPsNKaaaQ";